// Последние ошибки запросов в этой вкладке — для кнопки «Сообщить в IT».
// Хранятся только в памяти страницы, никуда не отправляются сами.

const LIMIT = 20
const entries = []

function pad(n) {
  return String(n).padStart(2, '0')
}

function stamp(date) {
  return `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`
}

export function rememberError(error, now = new Date()) {
  if (!error || typeof error !== 'object') return
  const config = error.config || {}
  entries.unshift({
    time: stamp(now),
    method: config.method ? String(config.method).toUpperCase() : '',
    url: config.url ? String(config.url).split('?')[0] : '',
    status: error.response?.status || null,
    message: error.message || '',
    technical: error.technicalMessage || '',
  })
  if (entries.length > LIMIT) entries.length = LIMIT
}

export function recentErrors(limit = LIMIT) {
  return entries.slice(0, limit)
}

export function clearErrors() {
  entries.length = 0
}
